import { generateUtilityClass, generateUtilityClasses } from '../styles/classes';
export var titleBlockComponentName = 'QuantumTitleBlock';
export function getTitleBlockUtilityClass(slot) {
    return generateUtilityClass(titleBlockComponentName, slot);
}
export var titleBlockClasses = generateUtilityClasses(titleBlockComponentName, ['root', 'title', 'description']);
